"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerStatusNewsToJSON = exports.CustomerStatusNewsFromJSONTyped = exports.CustomerStatusNewsFromJSON = void 0;
function CustomerStatusNewsFromJSON(json) {
    return CustomerStatusNewsFromJSONTyped(json, false);
}
exports.CustomerStatusNewsFromJSON = CustomerStatusNewsFromJSON;
function CustomerStatusNewsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'returnedItems': json['returnedItems'],
        'maturities': json['maturities'],
        'shipments': json['shipments'],
        'overall': json['overall'],
    };
}
exports.CustomerStatusNewsFromJSONTyped = CustomerStatusNewsFromJSONTyped;
function CustomerStatusNewsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'returnedItems': value.returnedItems,
        'maturities': value.maturities,
        'shipments': value.shipments,
        'overall': value.overall,
    };
}
exports.CustomerStatusNewsToJSON = CustomerStatusNewsToJSON;
//# sourceMappingURL=CustomerStatusNews.js.map